var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCollectRecordTime = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "start icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.25H12C12.1989 8.25 12.3897 8.32902 12.5303 8.46967C12.671 8.61032 12.75 8.80109 12.75 9C12.75 9.19891 12.671 9.38968 12.5303 9.53033C12.3897 9.67098 12.1989 9.75 12 9.75H9C8.80109 9.75 8.61032 9.67098 8.46967 9.53033C8.32902 9.38968 8.25 9.19891 8.25 9V6C8.25 5.80109 8.32902 5.61032 8.46967 5.46967C8.61032 5.32902 8.80109 5.25 9 5.25C9.19891 5.25 9.38968 5.32902 9.53033 5.46967C9.67098 5.61032 9.75 5.80109 9.75 6V8.25Z",
    fill: "#82993C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83323 2.76398C6.0666 1.93987 7.51664 1.5 9 1.5C9.98492 1.5 10.9602 1.69399 11.8701 2.0709C12.7801 2.44781 13.6069 3.00026 14.3033 3.6967C14.9997 4.39314 15.5522 5.21993 15.9291 6.12987C16.306 7.03982 16.5 8.01509 16.5 9C16.5 10.4834 16.0601 11.9334 15.236 13.1668C14.4119 14.4001 13.2406 15.3614 11.8701 15.9291C10.4997 16.4968 8.99168 16.6453 7.53683 16.3559C6.08197 16.0665 4.7456 15.3522 3.6967 14.3033C2.64781 13.2544 1.9335 11.918 1.64411 10.4632C1.35472 9.00832 1.50325 7.50032 2.07091 6.12987C2.63856 4.75943 3.59986 3.58809 4.83323 2.76398ZM5.66658 13.9888C6.65328 14.6481 7.81332 15 9 15C10.5913 15 12.1174 14.3679 13.2426 13.2426C14.3679 12.1174 15 10.5913 15 9C15 7.81331 14.6481 6.65327 13.9888 5.66658C13.3295 4.67988 12.3925 3.91085 11.2961 3.45672C10.1997 3.0026 8.99335 2.88378 7.82946 3.11529C6.66558 3.3468 5.59648 3.91824 4.75736 4.75736C3.91825 5.59647 3.3468 6.66557 3.11529 7.82946C2.88378 8.99335 3.0026 10.1997 3.45673 11.2961C3.91085 12.3925 4.67989 13.3295 5.66658 13.9888Z",
    fill: "#82993C"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCollectRecordTime);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/collect-record-time.8dee8d887df3af3e25458a99da63fb46.svg";